import storage from 'redux-persist/lib/storage';

export const i18nPersistConfig = {
  key: 'i18n',
  storage: storage,
};
